import React, {useState, useEffect, forwardRef} from "react";
import {useDispatch} from "react-redux";
import {Draggable, Droppable, DragDropContext} from "react-beautiful-dnd";
import {DateTime} from "luxon";
import {startCase} from 'lodash'
import {getUUID} from "../../../utils/hashFuncs";
import validators from "../../../utils/forms/validators";
import FormModal from "../../theme/modals/FormModal";
import {mergeTemplateToApp} from "../../../store/calls/applicationData";
import {toggleGlobalLoader} from "../../../store/actions/session";
import {addErrorAlert, addSuccessAlert} from "../../../store/calls/alertLoadingDispatch";
import api from "../../../store/api";
import ConfirmModal from "../../theme/modals/ConfirmModal";




const handleAddOrEditRequest = (data) => {

    let promise;

    if (data.id) {
        promise = api.patch(`/loan-product-notes/${data.id}/`, data)
    } else {
        promise = api.post(`/loan-product-notes/`, data)
    }

    return promise.then(res => res.data)

}


const handleRemoveRequest = id => {
    return api.delete(`/loan-product-notes/${id}/`)
}





function DraggableNoteElement({id, index, title, note, order, onEdit, onDelete}) {

    return (
        <Draggable draggableId={`note-${id}`} index={index}>
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    {...provided.dragHandleProps}
                    data-testid="note-card"
                >
                    <div className="p-4 my-4 box">
                        <div className="is-flex is-justify-content-space-between">
                            <div className="mr-4">
                                <h4 className="is-size-5 has-text-primary">
                                    <span className="">{title}</span>
                                </h4>
                                <p>
                                    {note || <span className="has-text-grey-light">--</span>}
                                </p>
                            </div>
                            <div className="is-flex-shrink-0">
                                <a
                                    className="p-2"
                                    onClick={e => {
                                        e.preventDefault()
                                        onEdit()
                                    }}
                                >
                                    <i
                                        className="fas fa-edit has-text-primary"
                                    />
                                </a>
                                <a
                                    className="p-2"
                                    onClick={e => {
                                        e.preventDefault()
                                        onDelete()
                                    }}
                                >
                                    <i
                                        className="fas fa-trash-alt has-text-danger"
                                    />
                                </a>

                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Draggable>
    )
}





function NoteBuilder({notes = [], loan_product = {}}) {

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [addEditModalOpen, setAddEditModalOpen] = useState(false);
    const [editingInstance, setEditingInstance] = useState(false)
    const [sortedNotes, setSortedNotes] = useState([]);

    useEffect(() => {
        console.log("notes", notes, "fire sort")
        let newsort = [...notes].sort((a,b) => a.order - b.order)
        console.log("post sort", newsort)
        setSortedNotes(newsort)
    }, [notes])

    const renderDeleteModal = () => <ConfirmModal
            type="warning"
            visible
            prompt={!!editingInstance && `Are you sure you want to remove the note titled ${editingInstance.title}
                                 from this loan?`}
            onCancel={() => {
                setEditingInstance(null);
                setDeleteModalOpen(false);
            }}
            onAccept={() => {
                handleRemoveRequest(editingInstance.id)
                    .then(() => {
                        setSortedNotes(sortedNotes.filter(d => d.id !== editingInstance.id))
                        setEditingInstance(null);
                        setDeleteModalOpen(false);
                    })
                    .catch(() => addErrorAlert("Deletion failed"))
            }}
        />


    const renderAddEditModal = () => <FormModal
        title={editingInstance ? 'Edit Note' : 'Create Note'}
        visible
        inputs={[
            {
                type: 'text',
                label: "Title",
                dataKey: "title",
                value: editingInstance?.title,
            },
            {
                type: 'textarea',
                label: "Note",
                dataKey: "note",
                value: editingInstance?.note,
            },
        ]}
        disableAutocomplete
        onSubmit={data => {

            // stuff to add in case it's a new note
            let newNoteContext = {loan_product: loan_product.id, order: sortedNotes.length}
            handleAddOrEditRequest({...newNoteContext, ...editingInstance, ...data})
                .then((_data) => {
                    if (data.id) {
                        setSortedNotes(sortedNotes.map(d => d.id === _data.id ? {..._data} : d))
                    } else {
                        setSortedNotes([...sortedNotes, {..._data}])
                    }
                    setAddEditModalOpen(false);
                    setEditingInstance(null);
                })
                .catch(() => addErrorAlert("Note updates failed."))
        }}
        onCancel={() => {
            setAddEditModalOpen(false);
            setEditingInstance(null);
        }}
    />


    const onDragEnd = (dragEvent) => {
        const {source, destination, draggableId} = dragEvent;

        // update the order by updating the position in the array
        let new_sort = [...sortedNotes]
        let old_sort = [...sortedNotes]
        let elem = new_sort.splice(source.index,1)[0]
        new_sort.splice(destination.index, 0, elem)
        new_sort = new_sort.map((d,i) => ({...d, order: i}))
        setSortedNotes(new_sort) // set order for db update


        return api.post('/bulk-update-notes/', {"notes": new_sort})
            .catch(() => {
                addErrorAlert("Reordering failed to save.")
                setSortedNotes(old_sort) // return it back to the way it was so screen reflects reality
            })
    }


    return (
        <div>
            <DragDropContext
                onDragEnd={onDragEnd}
            >
                <Droppable droppableId="notes-droppable">
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            data-testid="notes-droppable"
                        >
                            {(sortedNotes || []).map((d, i) => {
                                return <DraggableNoteElement
                                    key={d.id}
                                    {...d}
                                    index={i}
                                    onDelete={() => {
                                        setEditingInstance(d);
                                        setDeleteModalOpen(true);
                                    }}
                                    onEdit={() => {
                                        setEditingInstance(d);
                                        setAddEditModalOpen(true);
                                    }}
                                />
                            })}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>

            {/* addition element */}
            <div className="p-4 my-4 box cursor-is-pointer " onClick={() => {
                setAddEditModalOpen(true)
            }}>
                <h4 className="is-size-5 has-text-link">
                    <i className="fas fa-plus-circle"/>
                    <span className="ml-4">Add a note</span>
                </h4>
            </div>

            {addEditModalOpen && renderAddEditModal()}
            {deleteModalOpen && renderDeleteModal()}

        </div>

    )



}

export default NoteBuilder;